import defaultAttributes from '../defaultAttributes';

const AlignHorizontalDistributeStart = [
  'svg',
  defaultAttributes,
  [
    ['rect', { x: '4', y: '5', width: '6', height: '14', rx: '2' }],
    ['rect', { x: '14', y: '7', width: '6', height: '10', rx: '2' }],
    ['path', { d: 'M4 2v20' }],
    ['path', { d: 'M14 2v20' }],
  ],
];

export default AlignHorizontalDistributeStart;
